import * as Yup from "yup";

import { createForm } from "../../forms";

import type { TypeSafeReactLocalization } from "../../../composites";

export type TravelNoteFormFields = {
  endDate: DateString | null;
  startDate: DateString | null;
  travelDestinationCodes: string[];
};

const MAX_COUNTRIES = 19;

const translateValidationSchema = ({
  getString,
}: TypeSafeReactLocalization) => {
  const required = getString("form-generic-validation-required");
  return Yup.object({
    endDate: Yup.string().required(required).nonNullable(required),
    startDate: Yup.string().required(required).nonNullable(required),
    travelDestinationCodes: Yup.array()
      .of(Yup.string())
      .min(1, required)
      .max(
        MAX_COUNTRIES,
        getString("card-controls-travel-note-form-error-max-countries"),
      ),
  });
};
const initialValues: TravelNoteFormFields = {
  endDate: null,
  startDate: null,
  travelDestinationCodes: [],
};

export const createTravelNoteForm = createForm({
  initialValues,
  translateValidationSchema,
});
